import { render, staticRenderFns } from "./FieldExerciseType.vue?vue&type=template&id=52a96286&scoped=true"
import script from "./FieldExerciseType.vue?vue&type=script&lang=js"
export * from "./FieldExerciseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a96286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a96286')) {
      api.createRecord('52a96286', component.options)
    } else {
      api.reload('52a96286', component.options)
    }
    module.hot.accept("./FieldExerciseType.vue?vue&type=template&id=52a96286&scoped=true", function () {
      api.rerender('52a96286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldExerciseType.vue"
export default component.exports